var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4355_14510)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.3636 0H3.63636C1.62727 0 0 1.62727 0 3.63636V36.3636C0 38.3727 1.62727 40 3.63636 40H36.3636C38.3727 40 40 38.3727 40 36.3636V3.63636C40 1.62727 38.3727 0 36.3636 0ZM12.6436 32.7273H7.28V15.4691H12.6436V32.7273ZM9.90727 13.0018C8.17818 13.0018 6.78 11.6 6.78 9.87455C6.78 8.14909 8.18 6.74909 9.90727 6.74909C11.6309 6.74909 13.0327 8.15091 13.0327 9.87455C13.0327 11.6 11.6309 13.0018 9.90727 13.0018ZM32.7345 32.7273H27.3745V24.3345C27.3745 22.3327 27.3382 19.7582 24.5873 19.7582C21.7964 19.7582 21.3673 21.9382 21.3673 24.1891V32.7273H16.0073V15.4691H21.1527V17.8273H21.2255C21.9418 16.4709 23.6909 15.04 26.3 15.04C31.7309 15.04 32.7345 18.6145 32.7345 23.2618V32.7273Z",
    fill: "#1976D2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4355_14510"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.6234e3cbd707804f8f8977f921f350fb.svg";
export { ForwardRef as ReactComponent };